<template>
  <div class="w-full detail h-full overflow-y-auto overflow-x-hidden">
    <div class="w-full h-full p-10px flex flex-col">
      <!-- 区域基本信息 -->
      <div class="flex justify-start item-start mb-20px">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px ml-5px text-white">
          区域基本信息
        </span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">区域名称：</span>
        <span class="truncate">{{ currentRelationData.name }}</span>
      </div>
      <div class="w-full flex text-white mb-14px text-14px">
        <span class="w-150px truncate text-right">风险等级：</span>
        <span
          class="truncate"
          :class="textColorMap('areaLevelList')(currentRelationData.riskLevelName)"
          >{{ currentRelationData.riskLevelName }}</span
        >
      </div>
      <!-- 当前区域作业信息 -->
      <div class="flex justify-start item-start my-10px">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px ml-5px text-white">
          当前区域作业信息
        </span>
      </div>
      <div class="statistics_san">
        <el-table
          v-loading="loading"
          :data="tableData"
          :row-class-name="textColorMap('riskLevelList')"
          height="100%"
          class="transition-none"
          @row-click="handleRowClick($event)"
          highlight-current-row
        >
          <el-table-column label="" width="20">
            <template>
              <div class="selected-row"></div>
            </template>
          </el-table-column>
          <el-table-column label="作业类型" prop="type" show-overflow-tooltip></el-table-column>
          <el-table-column label="作业内容" prop="content" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="风险级别"
            prop="riskLevelName"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <!-- 当前区域人员信息 -->
      <div class="flex justify-start item-start my-10px">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px ml-5px text-white">
          当前区域人员信息
        </span>
      </div>
      <div
        class="flex-1 overflow-auto"
        v-if="personnelBelongAreaList && personnelBelongAreaList.length > 0"
      >
        <el-row
          type="flex"
          align="middle"
          class="h-36px table-choosed text-14px text-white"
          v-for="item in personnelBelongAreaList"
          :key="item.id"
        >
          <el-col :span="2"></el-col>
          <el-col :span="12" :title="item.name">
            <div
              class="w-max truncate flex items-center mr-15px cursor-pointer"
              @click="goPersonnel(item)"
            >
              <div class="h-14px w-15px user-icon mr-5px"></div>
              <span>{{ item.name }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div
              class="flex items-center mr-15px cursor-pointer text-[#08f0e0]"
              @click="goLocation(item)"
            >
              <div class="h-14px w-15px location-icon mr-5px"></div>
              <span>定位</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div
              class="flex items-center mr-15px cursor-pointer text-[#08f0e0]"
              @click="goRoute(item)"
            >
              <div class="h-14px w-15px route-icon mr-5px"></div>
              <span>路线</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="w-full h-15vh flex justify-center items-center">
        <img src="../../../assets/images/no_data@1x.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
// import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import { PersonnelLocationApi } from '@wiz-api/dyw'
import personnelList from '../../../assets/js/componentMethods/personnelList'

const areaApi = new AreaApi()
const personnelLocationApi = new PersonnelLocationApi()

export default {
  name: 'risk-area-dyw',
  components: {},
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {},
  data() {
    return {
      // 是否正在查看历史轨迹
      isHistoricalTrajectory: false,
      // 是否正在创建历史轨迹
      isCreating: false,
      currentRelationData: {
        name: '',
        riskLevelName: '',
        riskLevelId: undefined,
      },
      areaLevelList: [
        {
          name: '重大风险',
          textColor: 'text-[#a01c0e]',
        },
        {
          name: '较大风险',
          textColor: 'text-[#ff6c00]',
        },
        {
          name: '一般风险',
          textColor: 'text-[#fdf66d]',
        },
        {
          name: '低风险',
          textColor: 'text-[#14a3f3]',
        },
      ],
      riskLevelList: [
        {
          name: '高风险',
          textColor: 'text-[#cf3629]',
        },
        {
          name: '中风险',
          textColor: 'text-[#e2820f]',
        },
        {
          name: '低风险',
          textColor: 'text-[#1892fe]',
        },
      ],
      tableData: [],
      personnelBelongAreaList: [],
      loading: false,
      areaId: ''
    }
  },
  watch: {
    'transferProps.areaId': {
      handler(newVal, oldVal) {
        if (newVal) {
          console.log('transferProps.areaId', newVal)
          this.getAreaDetail()
        }
      },
    },
    'transferProps.sceneId': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getPersonnelBelongAreaList()
        }
      },
    },
  },
  mounted() {
    this.getAreaDetail()
    // this.getAreaWorkingTitckets()
    // this.getPersonnelBelongAreaList()
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.addEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.addEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
  },
  methods: {
    // 获取当前区域作业信息
    async getAreaWorkingTitckets() {
      // if (!this.transferProps) return
      // if (!this.transferProps.areaId) return
      this.loading = true
      const [err, res] = await personnelLocationApi.getAreaWorkingTitckets({
        // areaId: this.transferProps.areaId,
        areaId: this.currentRelationData.areaId,
      }).catch((e) => { return e })
      this.loading = false
      if (!err) {
        this.tableData = res
      }
      // if(this.tableData.length === 0){
      //   this.tableData = [
      // {
      //     "type": "机械工作票",
      //     "content": "一期E、F空压机系统管道安装（不接入系统）",
      //     "riskLevel": 5,
      //     "riskLevelName": "动火作业",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期E、F空压机系统管道安装（不接入系统）",
      //     "riskLevel": 5,
      //     "riskLevelName": "吊装作业",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期E、F空压机系统管道安装（不接入系统）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期E、F空压机系统管道安装（不接入系统）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期E、F空压机系统管道安装（不接入系统）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "连廊窗户玻璃及外墙铝扣板安装施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "连廊窗户玻璃及外墙铝扣板安装施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "着火、爆炸",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "连廊窗户玻璃及外墙铝扣板安装施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "连廊窗户玻璃及外墙铝扣板安装施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "电气第一种工作票",
      //     "content": "充电桩系统安装、接线及电缆耐压试验",
      //     "riskLevel": 5,
      //     "riskLevelName": "触电",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "电气第一种工作票",
      //     "content": "充电桩系统安装、接线及电缆耐压试验",
      //     "riskLevel": 5,
      //     "riskLevelName": "走错间隔",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "天然气调压站西侧避雷针基础开挖及结构施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "机械伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "天然气调压站西侧避雷针基础开挖及结构施工",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期循环水区域搭设检修平台（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "工器具伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期循环水区域搭设检修平台（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期循环水区域搭设检修平台（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "着火",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期废水零排放系统B废水超滤装置漏水处理及脚手架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "机械伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期废水零排放系统B废水超滤装置漏水处理及脚手架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期废水零排放系统B废水超滤装置漏水处理及脚手架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "一期废水零排放系统B废水超滤装置漏水处理及脚手架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组B高速混床及树脂捕捉器内部检查",
      //     "riskLevel": 5,
      //     "riskLevelName": "受限空间作业",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组B高速混床及树脂捕捉器内部检查",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组B高速混床及树脂捕捉器内部检查",
      //     "riskLevel": 5,
      //     "riskLevelName": "窒息中毒",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组B高速混床及树脂捕捉器内部检查",
      //     "riskLevel": 5,
      //     "riskLevelName": "高处作业",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "粉尘",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高温",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "生活水池自来水临时补水手动阀检查",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组A水水热交换器开式循环水进口系统区域全厂安健环项目材料预制",
      //     "riskLevel": 5,
      //     "riskLevelName": "工器具伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组A水水热交换器开式循环水进口系统区域全厂安健环项目材料预制",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "#2机组A水水热交换器开式循环水进口系统区域全厂安健环项目材料预制",
      //     "riskLevel": 5,
      //     "riskLevelName": "着火",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组锅炉及辅助间区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体击打",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组锅炉及辅助间区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "粉尘",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组锅炉及辅助间区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高温",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组锅炉及辅助间区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组锅炉及辅助间区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "着火、爆炸",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "粉尘",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高温",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "（2025#1机组D级检修)#1机组主厂房及前置模块区域脚手架搭拆、保温拆除及恢复（详见工作内容清单）",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "全厂公用生活污水C曝气风机、预曝气风机皮带更换",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "全厂公用生活污水C曝气风机、预曝气风机皮带更换",
      //     "riskLevel": 5,
      //     "riskLevelName": "转动伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "全厂公用生活污水C污水提升泵安装（不进入水池内部）",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "厂外一期超高压供热管道位移指示器整改与油漆修补及手脚架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "机械伤害",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "厂外一期超高压供热管道位移指示器整改与油漆修补及手脚架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "物体打击",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "厂外一期超高压供热管道位移指示器整改与油漆修补及手脚架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "高处坠落",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "厂外一期超高压供热管道位移指示器整改与油漆修补及手脚架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "高温、高压",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // },
      // {
      //     "type": "机械工作票",
      //     "content": "厂外一期超高压供热管道位移指示器整改与油漆修补及手脚架搭拆",
      //     "riskLevel": 5,
      //     "riskLevelName": "高空落物",
      //     "area": "100",
      //     "userId": "e0abb0ad-9299-2e08-d0b2-22086d86ec34"
      // }
      //   ]
      // }
      console.log('获取当前区域作业信息', this.tableData)
    },
    // 获取当前区域人员信息
    async getPersonnelBelongAreaList() {
      if (!this.transferProps) return
      if (!this.transferProps.sceneId) return
      await personnelLocationApi.syncChronousPosition()
      const [err, res] = await personnelLocationApi.getArea({
        keyWord: this.currentRelationData.name,
        modelId: this.transferProps.sceneId,
      }).catch((e) => { return e })
      if (!err && Array.isArray(res) && res.length > 0) {
        // eslint-disable-next-line array-callback-return
        res.map((item) => {
          if (item.area === this.currentRelationData.name) {
            this.personnelBelongAreaList = item.positions?.map((item2) => {
              return {
                name: item2.userName,
                id: item2.userId,
                tagCode: item2.tagId,
              }
            })
          }
        })
      }
    //   else{
    //     const res = [
    // {
    //     "id": "8fbc7324-aaf3-8ec7-7bc3-3a147acdbb05",
    //     "area": "保安",
    //     "count": 1,
    //     "carCount": 0,
    //     "playerVisualAngleJson": "",
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"26.604683\",\"y\":\"-76.369843\",\"z\":\"-0.480000\"},{\"seqNo\":1,\"x\":\"27.219719\",\"y\":\"-47.580433\",\"z\":\"-0.480000\"},{\"seqNo\":2,\"x\":\"-4.513515\",\"y\":\"-49.651009\",\"z\":\"-0.300000\"},{\"seqNo\":3,\"x\":\"-4.782369\",\"y\":\"-79.926445\",\"z\":\"-0.300000\"},{\"seqNo\":4,\"x\":\"-4.782369\",\"y\":\"-79.926445\",\"z\":\"-0.300000\"},{\"seqNo\":5,\"x\":\"-4.322131\",\"y\":\"-82.150620\",\"z\":\"-0.300000\"},{\"seqNo\":6,\"x\":\"-4.322131\",\"y\":\"-82.150620\",\"z\":\"-0.300000\"},{\"seqNo\":7,\"x\":\"-3.826439\",\"y\":\"-81.768402\",\"z\":\"-0.300000\"},{\"seqNo\":8,\"x\":\"-3.826439\",\"y\":\"-81.768402\",\"z\":\"-0.300000\"}]",
    //     "height": 1,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": [
    //         {
    //             "userId": "73f7cd82-3f97-82a0-89b4-80564da41f79",
    //             "userName": "保安区保安",
    //             "organizationName": null,
    //             "id": "6c035bd3-9f64-4ab0-baa1-7ea04bfc2d4f",
    //             "mapId": "19",
    //             "x": 16.58,
    //             "y": -66.43,
    //             "z": 0.00,
    //             "tagId": "299131",
    //             "postitionTime": "2025-04-23 14:47:41",
    //             "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //             "siteId": "3a0743fd-2f61-51c2-3bfd-415e973ef230"
    //         }
    //     ]
    // },
    // {
    //     "id": "39127acf-b011-8830-adba-3a1388b2f806",
    //     "area": "测试低风险",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": "",
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-32.645691\",\"y\":\"-44.890186\",\"z\":\"0\"},{\"seqNo\":1,\"x\":\"-40.048615\",\"y\":\"-44.099979\",\"z\":\"0\"},{\"seqNo\":2,\"x\":\"-40.140282\",\"y\":\"-37.107346\",\"z\":\"0\"},{\"seqNo\":3,\"x\":\"-33.584488\",\"y\":\"-37.249893\",\"z\":\"0\"},{\"seqNo\":4,\"x\":\"-33.584488\",\"y\":\"-37.249893\",\"z\":\"0\"},{\"seqNo\":5,\"x\":\"-33.584488\",\"y\":\"-37.249893\",\"z\":\"0\"},{\"seqNo\":6,\"x\":\"-33.584488\",\"y\":\"-37.249893\",\"z\":\"0\"},{\"seqNo\":7,\"x\":\"-32.601593\",\"y\":\"-40.191051\",\"z\":\"0\"},{\"seqNo\":8,\"x\":\"-32.601593\",\"y\":\"-40.191051\",\"z\":\"0\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "8661be77-dfb8-2b79-4acc-3a1683dc7729",
    //     "area": "2#0m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-169.699982\",\"y\":\"-46.616390\",\"z\":\"0.351587\"},{\"seqNo\":1,\"x\":\"-170.083496\",\"y\":\"0.890098\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-84.882858\",\"y\":\"0.977868\",\"z\":\"0.000000\"},{\"seqNo\":3,\"x\":\"-84.974998\",\"y\":\"-46.497692\",\"z\":\"0.445655\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "e63c0b95-7156-f145-e839-3a1683f4bf23",
    //     "area": "电二蓄电池室2",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-181.989990\",\"y\":\"-5.971584\",\"z\":\"13.741347\"},{\"seqNo\":1,\"x\":\"-181.989990\",\"y\":\"-2.756955\",\"z\":\"13.752455\"},{\"seqNo\":2,\"x\":\"-172.836594\",\"y\":\"-2.750130\",\"z\":\"13.772876\"},{\"seqNo\":3,\"x\":\"-172.838333\",\"y\":\"-6.000290\",\"z\":\"13.788046\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "6b6e45fd-fbe0-2420-4df3-3a1683fdadaa",
    //     "area": "化水处理车间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-172.700012\",\"y\":\"-281.324707\",\"z\":\"0.035002\"},{\"seqNo\":1,\"x\":\"-182.102600\",\"y\":\"-280.850006\",\"z\":\"1.542053\"},{\"seqNo\":2,\"x\":\"-182.150009\",\"y\":\"-274.424927\",\"z\":\"1.212457\"},{\"seqNo\":3,\"x\":\"-172.722900\",\"y\":\"-274.149994\",\"z\":\"0.080859\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "8109b7b4-9325-c19d-cf9d-3a1683e2e514",
    //     "area": "2#机组配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-95.244286\",\"y\":\"-43.102104\",\"z\":\"0.030464\"},{\"seqNo\":1,\"x\":\"-95.345413\",\"y\":\"-23.781990\",\"z\":\"0.491535\"},{\"seqNo\":2,\"x\":\"-85.429176\",\"y\":\"-23.619053\",\"z\":\"0.031355\"},{\"seqNo\":3,\"x\":\"-85.429184\",\"y\":\"-43.071133\",\"z\":\"0.128546\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "91e476bb-723a-d2e2-4601-3a1683dd2052",
    //     "area": "1#机组配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"0.057510\",\"y\":\"-42.956066\",\"z\":\"0.025786\"},{\"seqNo\":1,\"x\":\"0.295841\",\"y\":\"-23.351141\",\"z\":\"0.160070\"},{\"seqNo\":2,\"x\":\"-9.335155\",\"y\":\"-23.351143\",\"z\":\"0.488365\"},{\"seqNo\":3,\"x\":\"-9.311507\",\"y\":\"-42.820580\",\"z\":\"0.025786\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "706f9502-9bd7-ceb0-fc6b-3a1683be7ea2",
    //     "area": "1#0m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-85.180176\",\"y\":\"-46.643459\",\"z\":\"0.000000\"},{\"seqNo\":1,\"x\":\"-84.836891\",\"y\":\"1.000008\",\"z\":\"0.383578\"},{\"seqNo\":2,\"x\":\"0.619985\",\"y\":\"-46.920376\",\"z\":\"-0.021274\"},{\"seqNo\":3,\"x\":\"-85.225006\",\"y\":\"-46.626175\",\"z\":\"0.064310\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "0a01fd91-0dec-3829-c7cd-3a1683f5557d",
    //     "area": "制冷站",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-184.272675\",\"y\":\"-79.099983\",\"z\":\"0.418299\"},{\"seqNo\":1,\"x\":\"-184.100006\",\"y\":\"-64.071136\",\"z\":\"1.112975\"},{\"seqNo\":2,\"x\":\"-164.699982\",\"y\":\"-63.946297\",\"z\":\"0.320912\"},{\"seqNo\":3,\"x\":\"-164.699997\",\"y\":\"-79.145393\",\"z\":\"0.372374\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "25750c81-54eb-535d-d045-3a1683f519e6",
    //     "area": "尿素站",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-184.500000\",\"y\":\"-95.000572\",\"z\":\"0.808022\"},{\"seqNo\":1,\"x\":\"-184.168060\",\"y\":\"-79.699989\",\"z\":\"1.434771\"},{\"seqNo\":2,\"x\":\"-164.699997\",\"y\":\"-79.594482\",\"z\":\"0.318684\"},{\"seqNo\":3,\"x\":\"-164.571640\",\"y\":\"-95.099983\",\"z\":\"0.502303\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "c53419e7-539b-a164-a282-3a1684001d5a",
    //     "area": "GIS楼18.2m走廊",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-172.800003\",\"y\":\"-46.620541\",\"z\":\"13.712753\"},{\"seqNo\":1,\"x\":\"-172.725616\",\"y\":\"0.966977\",\"z\":\"13.704999\"},{\"seqNo\":2,\"x\":\"-170.127792\",\"y\":\"0.990015\",\"z\":\"13.752823\"},{\"seqNo\":3,\"x\":\"-170.038757\",\"y\":\"-46.645775\",\"z\":\"13.704999\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "168c7166-504a-a87b-2666-3a1683ded6a5",
    //     "area": "1#燃机380配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-14.538037\",\"y\":\"-25.424673\",\"z\":\"0.000000\"},{\"seqNo\":1,\"x\":\"-14.365368\",\"y\":\"-7.757273\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-31.433439\",\"y\":\"-7.891613\",\"z\":\"0.000000\"},{\"seqNo\":3,\"x\":\"-31.303976\",\"y\":\"-25.461573\",\"z\":\"0.000000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "806d5291-f078-ee1b-f39f-3a1683e1acaf",
    //     "area": "1#110v蓄电池2",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-75.553680\",\"y\":\"-5.894304\",\"z\":\"0.049318\"},{\"seqNo\":1,\"x\":\"-84.779152\",\"y\":\"-5.885170\",\"z\":\"0.090840\"},{\"seqNo\":2,\"x\":\"-84.779152\",\"y\":\"-3.318533\",\"z\":\"0.093952\"},{\"seqNo\":3,\"x\":\"-75.585320\",\"y\":\"-3.300159\",\"z\":\"0.109786\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "8666c131-82d9-7df9-56b4-3a1683e5dc42",
    //     "area": "2#保安段配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-118.332375\",\"y\":\"-45.099998\",\"z\":\"0.073270\"},{\"seqNo\":1,\"x\":\"-126.098396\",\"y\":\"-45.096489\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-126.103455\",\"y\":\"-37.106552\",\"z\":\"0.000000\"},{\"seqNo\":3,\"x\":\"-118.305794\",\"y\":\"-37.106476\",\"z\":\"0.105356\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "addddf25-156f-564f-fd57-3a1683eceb10",
    //     "area": "1#13.7m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-83.975006\",\"y\":\"-46.356388\",\"z\":\"14.436627\"},{\"seqNo\":1,\"x\":\"-83.974998\",\"y\":\"0.717747\",\"z\":\"15.704224\"},{\"seqNo\":2,\"x\":\"-0.500000\",\"y\":\"0.128722\",\"z\":\"15.756141\"},{\"seqNo\":3,\"x\":\"0.289996\",\"y\":\"-46.228561\",\"z\":\"14.946492\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "4498fd82-64dd-a59c-719e-3a1683f1046f",
    //     "area": "#1锅炉高压变频室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-36.311043\",\"y\":\"-82.029877\",\"z\":\"14.287030\"},{\"seqNo\":1,\"x\":\"-46.100002\",\"y\":\"-82.710632\",\"z\":\"11.708841\"},{\"seqNo\":2,\"x\":\"-45.941769\",\"y\":\"-77.090988\",\"z\":\"13.921266\"},{\"seqNo\":3,\"x\":\"-35.644638\",\"y\":\"-77.090981\",\"z\":\"13.148043\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "254ee613-46bc-215d-f79d-3a1683f1404e",
    //     "area": "#1锅炉高温架间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-46.098675\",\"y\":\"-77.090988\",\"z\":\"11.533126\"},{\"seqNo\":1,\"x\":\"-45.752270\",\"y\":\"-72.890984\",\"z\":\"13.694046\"},{\"seqNo\":2,\"x\":\"-35.319248\",\"y\":\"-72.890991\",\"z\":\"12.349446\"},{\"seqNo\":3,\"x\":\"-35.200005\",\"y\":\"-77.041336\",\"z\":\"11.630157\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "786a3dcc-0906-19c3-6c07-3a1683e9013d",
    //     "area": "2#6.5m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-86.824409\",\"y\":\"-45.816734\",\"z\":\"10.918181\"},{\"seqNo\":1,\"x\":\"-169.100037\",\"y\":\"-46.020241\",\"z\":\"8.749227\"},{\"seqNo\":2,\"x\":\"-169.100006\",\"y\":\"0.006204\",\"z\":\"9.025640\"},{\"seqNo\":3,\"x\":\"-86.241310\",\"y\":\"0.990008\",\"z\":\"8.433253\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "67b284e8-f2f3-3240-4287-3a1683de1270",
    //     "area": "1#机6kv配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"0.943485\",\"y\":\"-22.558834\",\"z\":\"-0.090104\"},{\"seqNo\":1,\"x\":\"0.552038\",\"y\":\"-23.324171\",\"z\":\"-0.006817\"},{\"seqNo\":2,\"x\":\"0.510001\",\"y\":\"-3.578619\",\"z\":\"0.040782\"},{\"seqNo\":3,\"x\":\"-9.621195\",\"y\":\"-2.916960\",\"z\":\"0.000000\"},{\"seqNo\":4,\"x\":\"-9.682045\",\"y\":\"-22.701000\",\"z\":\"0.478249\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "89f7b2a4-1d9c-4489-6f24-3a1683df8151",
    //     "area": "1#机lCI变频室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-22.201086\",\"y\":\"-9.989022\",\"z\":\"0.079047\"},{\"seqNo\":1,\"x\":\"-32.601593\",\"y\":\"-9.992643\",\"z\":\"0.089502\"},{\"seqNo\":2,\"x\":\"-32.601593\",\"y\":\"-3.509129\",\"z\":\"0.432829\"},{\"seqNo\":3,\"x\":\"-22.201086\",\"y\":\"-3.366436\",\"z\":\"0.071405\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "6d8de8bf-81b4-870b-ff15-3a1683e0dbc7",
    //     "area": "1#220v蓄电池",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.768562\",\"y\":\"-13.600663\",\"z\":\"0.059367\"},{\"seqNo\":1,\"x\":\"-84.759865\",\"y\":\"-6.100296\",\"z\":\"0.130977\"},{\"seqNo\":2,\"x\":\"-75.646935\",\"y\":\"-6.100296\",\"z\":\"0.380853\"},{\"seqNo\":3,\"x\":\"-75.571289\",\"y\":\"-13.584626\",\"z\":\"0.025786\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "77795aae-9bbb-08d8-4cd1-3a1683e938e5",
    //     "area": "1#燃机励磁小间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"0.289999\",\"y\":\"-14.949257\",\"z\":\"6.622425\"},{\"seqNo\":1,\"x\":\"-9.948991\",\"y\":\"-14.968393\",\"z\":\"6.776211\"},{\"seqNo\":2,\"x\":\"-9.948991\",\"y\":\"-3.499297\",\"z\":\"6.675740\"},{\"seqNo\":3,\"x\":\"0.290000\",\"y\":\"-3.380829\",\"z\":\"6.564940\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "d7a99aed-4d39-a641-adae-3a1683e96f51",
    //     "area": "#1机组电气继电器室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.652969\",\"y\":\"-43.037300\",\"z\":\"7.019404\"},{\"seqNo\":1,\"x\":\"-84.417931\",\"y\":\"-31.449991\",\"z\":\"7.586015\"},{\"seqNo\":2,\"x\":\"-76.065796\",\"y\":\"-31.185637\",\"z\":\"6.858880\"},{\"seqNo\":3,\"x\":\"-76.053627\",\"y\":\"-43.072773\",\"z\":\"6.921978\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "75706b39-2bd4-25d2-af7e-3a1683ebeaf8",
    //     "area": "380照明检修配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-85.572891\",\"y\":\"-26.901312\",\"z\":\"6.610719\"},{\"seqNo\":1,\"x\":\"-95.653168\",\"y\":\"-26.894640\",\"z\":\"6.514081\"},{\"seqNo\":2,\"x\":\"-95.606384\",\"y\":\"-15.221893\",\"z\":\"6.510439\"},{\"seqNo\":3,\"x\":\"-85.574875\",\"y\":\"-15.200740\",\"z\":\"6.551499\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "c2730a49-8eea-70fe-6074-3a1683ea6819",
    //     "area": "#1机组直流设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.625397\",\"y\":\"-23.001137\",\"z\":\"7.028172\"},{\"seqNo\":1,\"x\":\"-84.597977\",\"y\":\"-13.160623\",\"z\":\"6.858879\"},{\"seqNo\":2,\"x\":\"-79.757477\",\"y\":\"-13.216375\",\"z\":\"6.858879\"},{\"seqNo\":3,\"x\":\"-80.192444\",\"y\":\"-22.538366\",\"z\":\"8.623602\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "e13169e1-c126-b4a9-1184-3a1683f58ec9",
    //     "area": "启动锅炉房",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-184.099991\",\"y\":\"-111.128540\",\"z\":\"1.291675\"},{\"seqNo\":1,\"x\":\"-184.253998\",\"y\":\"-95.699982\",\"z\":\"0.785436\"},{\"seqNo\":2,\"x\":\"-164.699997\",\"y\":\"-95.670288\",\"z\":\"0.696970\"},{\"seqNo\":3,\"x\":\"-164.700012\",\"y\":\"-111.312134\",\"z\":\"0.697900\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "a9aa8b3b-56e8-7d93-b57a-3a1683f5c454",
    //     "area": "化学精处理",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-150.676193\",\"y\":\"-111.099991\",\"z\":\"1.136405\"},{\"seqNo\":1,\"x\":\"-164.100006\",\"y\":\"-111.326950\",\"z\":\"0.521702\"},{\"seqNo\":2,\"x\":\"-164.279510\",\"y\":\"-95.699966\",\"z\":\"0.613501\"},{\"seqNo\":3,\"x\":\"-150.456146\",\"y\":\"-95.699974\",\"z\":\"0.549310\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "8c31fd53-320c-ad07-06d5-3a1683f48cc6",
    //     "area": "电二蓄电池室1",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-181.966049\",\"y\":\"-9.900481\",\"z\":\"13.820100\"},{\"seqNo\":1,\"x\":\"-181.941391\",\"y\":\"-6.200299\",\"z\":\"13.846156\"},{\"seqNo\":2,\"x\":\"-172.882431\",\"y\":\"-6.200299\",\"z\":\"13.851149\"},{\"seqNo\":3,\"x\":\"-172.800217\",\"y\":\"-9.864571\",\"z\":\"13.705000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "2572c254-42be-7cbc-171e-3a1683fe1d2e",
    //     "area": "加药及化学清理间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-123.200020\",\"y\":\"-304.149475\",\"z\":\"0.586219\"},{\"seqNo\":1,\"x\":\"-153.600021\",\"y\":\"-304.074036\",\"z\":\"1.251400\"},{\"seqNo\":2,\"x\":\"-153.967911\",\"y\":\"-295.549927\",\"z\":\"0.154117\"},{\"seqNo\":3,\"x\":\"-123.606689\",\"y\":\"-295.725067\",\"z\":\"1.611119\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "092106c8-656c-1d13-3a70-3a1683dfd9d5",
    //     "area": "1#保安段配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-40.364407\",\"y\":\"-46.689999\",\"z\":\"0.040783\"},{\"seqNo\":1,\"x\":\"-40.417397\",\"y\":\"-37.021183\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-32.601597\",\"y\":\"-37.110271\",\"z\":\"0.180525\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "4ee0ee83-df26-bfb6-7fbd-3a1683e14072",
    //     "area": "1#110v蓄电池1",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-75.588791\",\"y\":\"-8.650419\",\"z\":\"0.109174\"},{\"seqNo\":1,\"x\":\"-84.779129\",\"y\":\"-8.632101\",\"z\":\"0.038713\"},{\"seqNo\":2,\"x\":\"-84.779121\",\"y\":\"-6.112813\",\"z\":\"0.045308\"},{\"seqNo\":3,\"x\":\"-75.628090\",\"y\":\"-6.100295\",\"z\":\"0.163463\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "acd68f25-be49-1325-b7f1-3a1683e0546e",
    //     "area": "#1机凝结水泵变频室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.849503\",\"y\":\"-39.396618\",\"z\":\"0.000000\"},{\"seqNo\":1,\"x\":\"-85.094879\",\"y\":\"-29.241198\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-79.314484\",\"y\":\"-29.201426\",\"z\":\"0.429083\"},{\"seqNo\":3,\"x\":\"-79.153862\",\"y\":\"-39.370522\",\"z\":\"0.138805\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "494448f1-d4d6-d189-b909-3a1683e408ad",
    //     "area": "2#机组LCI变频室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-118.250633\",\"y\":\"-10.000486\",\"z\":\"0.060573\"},{\"seqNo\":1,\"x\":\"-118.251869\",\"y\":\"-3.360162\",\"z\":\"0.117796\"},{\"seqNo\":2,\"x\":\"-107.905281\",\"y\":\"-3.366834\",\"z\":\"0.065086\"},{\"seqNo\":3,\"x\":\"-107.905266\",\"y\":\"-9.975180\",\"z\":\"0.091350\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "1bfb7415-e069-ab23-b034-3a1683e7af0e",
    //     "area": "#2机凝结水泵变频室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-170.210968\",\"y\":\"-39.362644\",\"z\":\"0.000446\"},{\"seqNo\":1,\"x\":\"-170.107239\",\"y\":\"-29.217922\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-164.858017\",\"y\":\"-29.205013\",\"z\":\"0.043232\"},{\"seqNo\":3,\"x\":\"-164.858017\",\"y\":\"-39.365704\",\"z\":\"0.191476\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "b072d09f-91ca-1fc7-9a34-3a1683f61fb4",
    //     "area": "空压机房",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-150.300003\",\"y\":\"-95.096718\",\"z\":\"0.915158\"},{\"seqNo\":1,\"x\":\"-164.093582\",\"y\":\"-95.114418\",\"z\":\"0.578068\"},{\"seqNo\":2,\"x\":\"-164.096954\",\"y\":\"-64.188942\",\"z\":\"1.388722\"},{\"seqNo\":3,\"x\":\"-153.352524\",\"y\":\"-63.854038\",\"z\":\"0.000000\"},{\"seqNo\":4,\"x\":\"-153.175583\",\"y\":\"-71.499992\",\"z\":\"0.558474\"},{\"seqNo\":5,\"x\":\"-150.699997\",\"y\":\"-71.675369\",\"z\":\"2.149884\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "ebcd48c0-8c9c-eb03-b2c6-3a1683f665b6",
    //     "area": "1#锅炉汽包平台",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-32.241096\",\"y\":\"-98.178558\",\"z\":\"31.512722\"},{\"seqNo\":1,\"x\":\"-32.233101\",\"y\":\"-71.088524\",\"z\":\"31.250000\"},{\"seqNo\":2,\"x\":\"-12.728697\",\"y\":\"-71.184273\",\"z\":\"31.250000\"},{\"seqNo\":3,\"x\":\"-12.714123\",\"y\":\"-98.152618\",\"z\":\"31.250000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "c7eeb8b0-fc42-6040-4967-3a1683f6a106",
    //     "area": "2#锅炉汽包平台",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-118.028595\",\"y\":\"-98.178986\",\"z\":\"31.347485\"},{\"seqNo\":1,\"x\":\"-117.959839\",\"y\":\"-71.079002\",\"z\":\"31.728960\"},{\"seqNo\":2,\"x\":\"-98.470016\",\"y\":\"-71.152679\",\"z\":\"31.273317\"},{\"seqNo\":3,\"x\":\"-98.340660\",\"y\":\"-98.178993\",\"z\":\"31.307957\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "c63a4cc9-295b-9a1b-e22e-3a1683fecbbe",
    //     "area": "循环水泵房1",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-163.049973\",\"y\":\"-161.697601\",\"z\":\"0.375155\"},{\"seqNo\":1,\"x\":\"-162.861252\",\"y\":\"-140.566711\",\"z\":\"-0.480000\"},{\"seqNo\":2,\"x\":\"-142.325394\",\"y\":\"-140.541077\",\"z\":\"-0.480000\"},{\"seqNo\":3,\"x\":\"-142.366440\",\"y\":\"-161.699966\",\"z\":\"0.291144\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "d10f0d52-b0f4-873c-217b-3a1683ff303f",
    //     "area": "循环水泵房3",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-120.432930\",\"y\":\"-161.699982\",\"z\":\"0.243984\"},{\"seqNo\":1,\"x\":\"-120.399467\",\"y\":\"-140.703964\",\"z\":\"0.700952\"},{\"seqNo\":2,\"x\":\"-99.700020\",\"y\":\"-140.850998\",\"z\":\"0.763107\"},{\"seqNo\":3,\"x\":\"-99.616554\",\"y\":\"-161.699951\",\"z\":\"0.141959\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "fd0aa1e2-0e51-7663-2eb7-3a1683e21a2f",
    //     "area": "2#机6kv配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-85.429169\",\"y\":\"-23.329081\",\"z\":\"0.137712\"},{\"seqNo\":1,\"x\":\"-95.154640\",\"y\":\"-23.277021\",\"z\":\"0.332579\"},{\"seqNo\":2,\"x\":\"-95.112137\",\"y\":\"-3.300159\",\"z\":\"0.229099\"},{\"seqNo\":3,\"x\":\"-85.429184\",\"y\":\"-3.302413\",\"z\":\"0.461212\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "4765eff0-bc54-e41f-0ef7-3a1683eba63a",
    //     "area": "#2汽机励磁设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-165.420486\",\"y\":\"-12.893166\",\"z\":\"6.858880\"},{\"seqNo\":1,\"x\":\"-170.107834\",\"y\":\"-12.900625\",\"z\":\"6.870396\"},{\"seqNo\":2,\"x\":\"-170.040665\",\"y\":\"-3.350070\",\"z\":\"6.869954\"},{\"seqNo\":3,\"x\":\"-165.468307\",\"y\":\"-3.350070\",\"z\":\"6.899889\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "84c9b095-33dd-ecf2-de5e-3a1683eb667d",
    //     "area": "#2机组直流设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-170.104889\",\"y\":\"-22.991230\",\"z\":\"6.858880\"},{\"seqNo\":1,\"x\":\"-170.108337\",\"y\":\"-13.172015\",\"z\":\"7.047548\"},{\"seqNo\":2,\"x\":\"-165.407883\",\"y\":\"-13.157127\",\"z\":\"7.211612\"},{\"seqNo\":3,\"x\":\"-165.699829\",\"y\":\"-22.602350\",\"z\":\"8.660622\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "b8968a86-d19f-2603-358c-3a1683fe4f3a",
    //     "area": "药瓶储藏间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-117.604233\",\"y\":\"-304.345947\",\"z\":\"0.020081\"},{\"seqNo\":1,\"x\":\"-122.625076\",\"y\":\"-303.849976\",\"z\":\"1.362945\"},{\"seqNo\":2,\"x\":\"-122.776108\",\"y\":\"-295.549988\",\"z\":\"0.008701\"},{\"seqNo\":3,\"x\":\"-117.605347\",\"y\":\"-295.546356\",\"z\":\"0.000000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "229175b9-b450-a784-e84e-3a1683f31e01",
    //     "area": "#2锅炉CEMS间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-123.384727\",\"y\":\"-92.090988\",\"z\":\"11.543574\"},{\"seqNo\":1,\"x\":\"-126.371269\",\"y\":\"-92.084846\",\"z\":\"11.500000\"},{\"seqNo\":2,\"x\":\"-126.383369\",\"y\":\"-88.791832\",\"z\":\"11.505282\"},{\"seqNo\":3,\"x\":\"-123.382004\",\"y\":\"-88.846771\",\"z\":\"11.881705\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "3ccfe08a-2239-db77-6dd9-3a1683f38b7b",
    //     "area": "#2锅炉高压变频器室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-121.090294\",\"y\":\"-82.790993\",\"z\":\"11.872910\"},{\"seqNo\":1,\"x\":\"-131.799988\",\"y\":\"-82.771523\",\"z\":\"11.536222\"},{\"seqNo\":2,\"x\":\"-131.800003\",\"y\":\"-77.318367\",\"z\":\"11.545085\"},{\"seqNo\":3,\"x\":\"-122.061035\",\"y\":\"-77.736511\",\"z\":\"14.766227\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "dd9b96ff-c1b4-1661-7590-3a1683f3c162",
    //     "area": "#2锅炉高温架间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-131.800003\",\"y\":\"-77.045944\",\"z\":\"11.531484\"},{\"seqNo\":1,\"x\":\"-131.728226\",\"y\":\"-72.890984\",\"z\":\"11.720057\"},{\"seqNo\":2,\"x\":\"-120.934784\",\"y\":\"-72.890984\",\"z\":\"11.612136\"},{\"seqNo\":3,\"x\":\"-120.900017\",\"y\":\"-77.073952\",\"z\":\"11.603892\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "840fac2d-e815-726d-f252-3a1683ff00e8",
    //     "area": "循环水泵房2",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-121.191513\",\"y\":\"-161.699966\",\"z\":\"0.265040\"},{\"seqNo\":1,\"x\":\"-142.049988\",\"y\":\"-161.693848\",\"z\":\"0.103842\"},{\"seqNo\":2,\"x\":\"-141.850006\",\"y\":\"-140.836166\",\"z\":\"0.289634\"},{\"seqNo\":3,\"x\":\"-121.450012\",\"y\":\"-141.043945\",\"z\":\"1.034943\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "7977c1e1-0993-5836-661c-3a168400513a",
    //     "area": "备品备件间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-181.990005\",\"y\":\"-34.527317\",\"z\":\"14.389624\"},{\"seqNo\":1,\"x\":\"-181.936142\",\"y\":\"-15.002512\",\"z\":\"14.199095\"},{\"seqNo\":2,\"x\":\"-172.849640\",\"y\":\"-14.944878\",\"z\":\"14.199095\"},{\"seqNo\":3,\"x\":\"-172.815277\",\"y\":\"-34.601135\",\"z\":\"14.199095\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "2f5f141d-2184-306e-803f-3a168400adc1",
    //     "area": "通讯蓄电池室2",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-172.802673\",\"y\":\"-9.900481\",\"z\":\"13.846954\"},{\"seqNo\":1,\"x\":\"-181.621582\",\"y\":\"-9.599983\",\"z\":\"15.532199\"},{\"seqNo\":2,\"x\":\"-181.989990\",\"y\":\"-6.213288\",\"z\":\"13.989034\"},{\"seqNo\":3,\"x\":\"-172.800003\",\"y\":\"-6.200910\",\"z\":\"13.767109\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "cfe51c70-a742-0763-1cd3-3a1683e57e22",
    //     "area": "2#燃机380配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-113.153145\",\"y\":\"-14.509326\",\"z\":\"0.000000\"},{\"seqNo\":1,\"x\":\"-103.232849\",\"y\":\"-14.323506\",\"z\":\"0.000000\"},{\"seqNo\":2,\"x\":\"-103.174240\",\"y\":\"-24.191273\",\"z\":\"0.000000\"},{\"seqNo\":3,\"x\":\"-113.296677\",\"y\":\"-24.126732\",\"z\":\"0.000000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "2782ebf3-2527-5820-4670-3a1683eaa7c3",
    //     "area": "#1汽机励磁设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-79.714806\",\"y\":\"-12.900630\",\"z\":\"6.874506\"},{\"seqNo\":1,\"x\":\"-84.640320\",\"y\":\"-12.900062\",\"z\":\"6.858880\"},{\"seqNo\":2,\"x\":\"-84.632675\",\"y\":\"-3.374742\",\"z\":\"6.858880\"},{\"seqNo\":3,\"x\":\"-79.703484\",\"y\":\"-3.373183\",\"z\":\"6.858879\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "c9d29dd0-9a1a-f960-e3cc-3a1683e9a2d8",
    //     "area": "#1机组ups设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.652962\",\"y\":\"-26.850489\",\"z\":\"7.145706\"},{\"seqNo\":1,\"x\":\"-84.652954\",\"y\":\"-23.230467\",\"z\":\"6.996757\"},{\"seqNo\":2,\"x\":\"-76.089462\",\"y\":\"-23.201149\",\"z\":\"6.943832\"},{\"seqNo\":3,\"x\":\"-76.098663\",\"y\":\"-26.901314\",\"z\":\"7.062187\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "9dc25e7a-0b58-7440-6450-3a1683e63b09",
    //     "area": "1#凝结水泵地坑",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-70.581367\",\"y\":\"-39.349998\",\"z\":\"-6.575232\"},{\"seqNo\":1,\"x\":\"-76.549995\",\"y\":\"-39.332287\",\"z\":\"-6.925890\"},{\"seqNo\":2,\"x\":\"-76.149338\",\"y\":\"-31.720520\",\"z\":\"-2.000000\"},{\"seqNo\":3,\"x\":\"-70.648476\",\"y\":\"-31.114584\",\"z\":\"-7.304960\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "22df8df9-8e97-41c8-b1cb-3a1683eb354c",
    //     "area": "#2机组ups设备室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-170.108353\",\"y\":\"-26.866129\",\"z\":\"6.948210\"},{\"seqNo\":1,\"x\":\"-170.108337\",\"y\":\"-23.246872\",\"z\":\"7.002282\"},{\"seqNo\":2,\"x\":\"-161.784210\",\"y\":\"-23.203976\",\"z\":\"6.858879\"},{\"seqNo\":3,\"x\":\"-161.757797\",\"y\":\"-26.893282\",\"z\":\"6.889145\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "59e3b24e-af74-d3e2-3b79-3a1683e6b836",
    //     "area": "2#凝结水泵地坑",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-162.949997\",\"y\":\"-39.110516\",\"z\":\"-4.314711\"},{\"seqNo\":1,\"x\":\"-162.899353\",\"y\":\"-31.325201\",\"z\":\"-2.000000\"},{\"seqNo\":2,\"x\":\"-156.250015\",\"y\":\"-31.042812\",\"z\":\"-6.574231\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "04e741c1-f2b7-d53d-4d2e-3a1683ffe7ae",
    //     "area": "GIS楼18.2m层",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-181.952026\",\"y\":\"-46.689983\",\"z\":\"13.786132\"},{\"seqNo\":1,\"x\":\"-181.990021\",\"y\":\"0.884521\",\"z\":\"13.859643\"},{\"seqNo\":2,\"x\":\"-172.830887\",\"y\":\"0.990015\",\"z\":\"13.756289\"},{\"seqNo\":3,\"x\":\"-172.800018\",\"y\":\"-46.681820\",\"z\":\"13.812769\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "2ac2639c-481d-108f-c0b2-3a1683e8542b",
    //     "area": "1#6.5m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.868523\",\"y\":\"-46.410721\",\"z\":\"6.505000\"},{\"seqNo\":1,\"x\":\"-84.730812\",\"y\":\"0.990007\",\"z\":\"6.709867\"},{\"seqNo\":2,\"x\":\"0.290000\",\"y\":\"-0.254618\",\"z\":\"7.474556\"},{\"seqNo\":3,\"x\":\"0.289996\",\"y\":\"-46.273239\",\"z\":\"7.751544\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "f1f05d44-ab9a-2735-98bc-3a1683eaeb82",
    //     "area": "#2机组电气继电器室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-161.757782\",\"y\":\"-43.238041\",\"z\":\"6.873024\"},{\"seqNo\":1,\"x\":\"-170.108322\",\"y\":\"-43.226166\",\"z\":\"6.871097\"},{\"seqNo\":2,\"x\":\"-170.095535\",\"y\":\"-31.120708\",\"z\":\"6.858879\"},{\"seqNo\":3,\"x\":\"-161.893539\",\"y\":\"-31.101515\",\"z\":\"7.191892\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "d571c303-a25e-7d5f-dae7-3a168400e246",
    //     "area": "通讯蓄电池室1",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-172.800018\",\"y\":\"-5.996089\",\"z\":\"13.761577\"},{\"seqNo\":1,\"x\":\"-181.976608\",\"y\":\"-6.000289\",\"z\":\"13.771835\"},{\"seqNo\":2,\"x\":\"-181.830795\",\"y\":\"-2.750130\",\"z\":\"14.111896\"},{\"seqNo\":3,\"x\":\"-172.800018\",\"y\":\"-2.794362\",\"z\":\"13.792740\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "fb3a33fe-db7c-fcba-d842-3a1683f2e872",
    //     "area": "#2锅炉mcc配电间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-35.217949\",\"y\":\"-98.286049\",\"z\":\"11.629378\"},{\"seqNo\":1,\"x\":\"-46.095325\",\"y\":\"-98.249092\",\"z\":\"11.500000\"},{\"seqNo\":2,\"x\":\"-46.100006\",\"y\":\"-92.305222\",\"z\":\"11.673902\"},{\"seqNo\":3,\"x\":\"-35.209801\",\"y\":\"-92.316422\",\"z\":\"11.500000\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "706a93dd-b4ce-7658-05ab-3a1683ec23cc",
    //     "area": "#2燃机励磁小间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-95.622810\",\"y\":\"-14.930538\",\"z\":\"6.510440\"},{\"seqNo\":1,\"x\":\"-95.573959\",\"y\":\"-3.360161\",\"z\":\"6.743811\"},{\"seqNo\":2,\"x\":\"-85.612976\",\"y\":\"-3.365089\",\"z\":\"6.510440\"},{\"seqNo\":3,\"x\":\"-85.583061\",\"y\":\"-14.968526\",\"z\":\"6.510440\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "b1d116af-7768-1fe2-6279-3a1683f2b0be",
    //     "area": "#1锅炉mcc配电间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-46.065491\",\"y\":\"-98.286064\",\"z\":\"11.556973\"},{\"seqNo\":1,\"x\":\"-46.091618\",\"y\":\"-92.290993\",\"z\":\"11.634395\"},{\"seqNo\":2,\"x\":\"-36.311054\",\"y\":\"-92.855919\",\"z\":\"14.329303\"},{\"seqNo\":3,\"x\":\"-35.200012\",\"y\":\"-98.255333\",\"z\":\"11.528833\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "ce246329-522a-0f22-bac4-3a1683fde303",
    //     "area": "其他辅助车间配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-182.100021\",\"y\":\"-304.009552\",\"z\":\"0.884146\"},{\"seqNo\":1,\"x\":\"-181.587463\",\"y\":\"-296.075928\",\"z\":\"1.870136\"},{\"seqNo\":2,\"x\":\"-166.500000\",\"y\":\"-295.550232\",\"z\":\"0.041942\"},{\"seqNo\":3,\"x\":\"-166.500000\",\"y\":\"-304.341705\",\"z\":\"0.049302\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "2f6578c8-b28a-2edf-a211-3a1683fe84d4",
    //     "area": "锅炉水电配电室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-98.200012\",\"y\":\"-304.200287\",\"z\":\"0.743453\"},{\"seqNo\":1,\"x\":\"-117.400017\",\"y\":\"-304.341431\",\"z\":\"0.126092\"},{\"seqNo\":2,\"x\":\"-116.500046\",\"y\":\"-296.010895\",\"z\":\"2.022919\"},{\"seqNo\":3,\"x\":\"-98.141014\",\"y\":\"-295.549988\",\"z\":\"0.465773\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "bd9bfa36-420d-d752-8fba-3a1683ff617f",
    //     "area": "循环水泵房4",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-78.688400\",\"y\":\"-161.696381\",\"z\":\"0.584801\"},{\"seqNo\":1,\"x\":\"-99.300018\",\"y\":\"-161.645569\",\"z\":\"0.329833\"},{\"seqNo\":2,\"x\":\"-99.100021\",\"y\":\"-140.867752\",\"z\":\"0.860228\"},{\"seqNo\":3,\"x\":\"-78.700005\",\"y\":\"-140.846848\",\"z\":\"0.633287\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "359ce3b7-9da3-a922-cf5f-3a1684007e65",
    //     "area": "通讯机房",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-181.977936\",\"y\":\"-14.789162\",\"z\":\"13.704998\"},{\"seqNo\":1,\"x\":\"-181.989990\",\"y\":\"-10.035666\",\"z\":\"16.372246\"},{\"seqNo\":2,\"x\":\"-172.828583\",\"y\":\"-10.204062\",\"z\":\"14.199095\"},{\"seqNo\":3,\"x\":\"-172.799988\",\"y\":\"-14.886568\",\"z\":\"14.398896\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "6b5a8113-656d-eeed-9971-3a1683ed297f",
    //     "area": "2#13.7m层区域",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-84.974991\",\"y\":\"0.653165\",\"z\":\"15.764113\"},{\"seqNo\":1,\"x\":\"-169.099991\",\"y\":\"-0.039032\",\"z\":\"17.348383\"},{\"seqNo\":2,\"x\":\"-169.100021\",\"y\":\"-46.139427\",\"z\":\"15.064572\"},{\"seqNo\":3,\"x\":\"-86.225014\",\"y\":\"-45.873161\",\"z\":\"17.827139\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "fd62341c-e18e-307c-8b7f-3a1683f26284",
    //     "area": "#1锅炉cems间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-37.704185\",\"y\":\"-92.090996\",\"z\":\"11.605150\"},{\"seqNo\":1,\"x\":\"-40.683384\",\"y\":\"-92.031120\",\"z\":\"11.833604\"},{\"seqNo\":2,\"x\":\"-40.683388\",\"y\":\"-88.801964\",\"z\":\"11.555526\"},{\"seqNo\":3,\"x\":\"-37.714371\",\"y\":\"-88.790993\",\"z\":\"11.732784\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "16cd22c9-2384-36aa-85dd-3a1683f41659",
    //     "area": "#2锅炉仪表盘间",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-131.766571\",\"y\":\"-72.690971\",\"z\":\"11.520597\"},{\"seqNo\":1,\"x\":\"-131.300003\",\"y\":\"-68.795517\",\"z\":\"13.017344\"},{\"seqNo\":2,\"x\":\"-121.961037\",\"y\":\"-69.081047\",\"z\":\"14.426023\"},{\"seqNo\":3,\"x\":\"-121.961044\",\"y\":\"-72.222099\",\"z\":\"14.554723\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // },
    // {
    //     "id": "003b1bd6-c450-6e54-0f80-3a1683f45354",
    //     "area": "升压站继电器室",
    //     "count": 0,
    //     "carCount": 0,
    //     "playerVisualAngleJson": null,
    //     "coordinate": "[{\"seqNo\":0,\"x\":\"-172.801208\",\"y\":\"-34.651688\",\"z\":\"14.276555\"},{\"seqNo\":1,\"x\":\"-181.954453\",\"y\":\"-34.589855\",\"z\":\"14.199095\"},{\"seqNo\":2,\"x\":\"-181.700195\",\"y\":\"-10.727040\",\"z\":\"15.570000\"},{\"seqNo\":3,\"x\":\"-172.895187\",\"y\":\"-10.160966\",\"z\":\"14.199095\"}]",
    //     "height": 2,
    //     "modelId": "d7885d2f-4487-7665-c248-3a1326f6064f",
    //     "positions": []
    // }
    //     ]
    //     res.map(item=>{
    //       if(item.area == this.currentRelationData.name){
    //         this.personnelBelongAreaList = item.positions?.map((item2) => {
    //           return {
    //             name: item2.userName,
    //             id: item2.userId,
    //             tagCode: item2.tagId,
    //           }
    //         })
    //       }
    //     })
    //   }
    },
    // 获取区域详情
    async getAreaDetail() {
      // if (!this.transferProps) return
      // if (!this.transferProps.areaId) return
      // const [err, res] = await areaApi.get(this.transferProps.areaId).catch((e) => { return e })
      // console.log("获取区域详情",res);
      // if (!err) {
      //   const { name, riskLevelName } = res
      //   this.currentRelationData.name = name || '/'
      //   this.currentRelationData.riskLevelName = riskLevelName || '/'
      // }

      const [err, res] = await personnelLocationApi.getWorkingAreaList({
        modelId: this.transferProps.sceneId,
        skipCount: 0,
        maxResultCount: 1000,
      }).catch((e) => { return e })

      // if(!res){
      //     res = [
      //       {
      //         seqNo: 0,
      //         id: '8fbc7324-aaf3-8ec7-7bc3-3a147acdbb05',
      //         modelId: 'd7885d2f-4487-7665-c248-3a1326f6064f',
      //         mapId: null,
      //         mapName: null,
      //         code: '100',
      //         name: '保安',
      //         areaTypeId: '7ff562ed-cb37-d818-436a-3a1388b15670',
      //         areaTypeName: '个人责任区域',
      //         height: 1,
      //         leaderId: null,
      //         leaderName: null,
      //         playerVisualAngleJson: '',
      //         coordinate: '[{"seqNo":0,"x":"26.604683","y":"-76.369843","z":"-0.480000"},{"seqNo":1,"x":"27.219719","y":"-47.580433","z":"-0.480000"},{"seqNo":2,"x":"-4.513515","y":"-49.651009","z":"-0.300000"},{"seqNo":3,"x":"-4.782369","y":"-79.926445","z":"-0.300000"},{"seqNo":4,"x":"-4.782369","y":"-79.926445","z":"-0.300000"},{"seqNo":5,"x":"-4.322131","y":"-82.150620","z":"-0.300000"},{"seqNo":6,"x":"-4.322131","y":"-82.150620","z":"-0.300000"},{"seqNo":7,"x":"-3.826439","y":"-81.768402","z":"-0.300000"},{"seqNo":8,"x":"-3.826439","y":"-81.768402","z":"-0.300000"}]',
      //         riskLevelId: '50e2f0fc-76d4-3ca6-0ef3-3a1388b15670',
      //         riskLevelName: '蓝色',
      //         isDisplayName: false,
      //         fenceId: 'b4f0353a-499a-64e6-14ee-3a147ad5483a',
      //         thirdFenceId: null,
      //         thirdAreaId: null,
      //         alarmCount: 0,
      //         realTimePersonCount: 0,
      //         isDrawed: true,
      //         areaGroupIds: [],
      //         areaGroupList: [],
      //         parentId: null,
      //         children: null
      //       }
      //     ]
      // }
      if (!res) return
      console.log('获取区域详情', res)
      const { name, riskLevelName, id, code } = res[0]
      this.currentRelationData.name = name || '/'
      this.currentRelationData.riskLevelName = riskLevelName || '/'
      this.currentRelationData.areaId = id
      // }
      // 注释掉一打开作业视图就同步打开轨迹回放
      // this.$emit('operateTrajectory', {
      //   visible: true,
      //   personnelId: id,
      //   tagCode: code,
      // })
      this.getAreaWorkingTitckets()
      this.getPersonnelBelongAreaList()
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isHistoricalTrajectory = e.detail?.isOpen
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialEndHandler() {
      this.isCreating = false
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialHandler() {
      this.isCreating = true
    },
    textColorMap(type) {
      return (val) => {
        return (
          this[type].find((i) => {
            // eslint-disable-next-line eqeqeq
            if (type === 'riskLevelList') {
              return i.name === val?.row?.riskLevelName
            }
            return i.name === val
          })?.textColor || ''
        )
      }
    },
    handleRowClick(row) {
      console.log('点击 PersonnelInfo', row)
      this.$emit('PersonnelInfo', row)
    },
    // 人员信息
    goPersonnel(data) {
      console.log('点击当前区域人员信息', data)
      personnelList.openPersonnelDetail(data.id, data.tagCode)
    },
    // 人员动态定位
    goLocation(data) {
      // 如果正在查看历史轨迹，提示退出
      if (this.isHistoricalTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
      }
      const label = _.find(this.labelList, ['code', 'PersonnelList'])
      if (!label?.checked) {
        this.$message.warning({
          showClose: true,
          message: '没有勾选人员标签，请先勾选',
        })
      }
      personnelList.openPersonnelDetail(data.id, data.tagCode)
    },
    // 人员动态路线
    goRoute(data) {
      if (this.isCurrentId === data.id) return
      if (this.isCreating) {
        this.$message.warning({
          showClose: true,
          message: '上一个人员数据未加载完，请稍后',
        })
      }
      this.isCreating = true
      this.isCurrentId = data.id
      this.$emit('operateTrajectory', {
        visible: true,
        personnelId: data.id,
        tagCode: data.tagCode,
      })
    },
  },
  beforeDestroy() {
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.removeEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.removeEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__empty-block {
  background-image: url('../../../assets/images/no_data@1x.png');
  background-repeat: no-repeat;
  background-position: center;
}

.table-choosed {
  background: url('../../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
}
.user-icon {
  background: url('../../../assets/images/control/user.png');
  background-size: 100% 100%;
}
.location-icon {
  background: url('../../../assets/images/control/location.png');
  background-size: 100% 100%;
}
.route-icon {
  background: url('../../../assets/images/control/route.png');
  background-size: 100% 100%;
}

.statistics_san {
  width: 100%;
  height: 30vh;
}

// 滚动条样式
.detail::-webkit-scrollbar {
  width: 5px !important;
  height: 2px !important;
  background: rgba(24, 41, 72, 0.4);
}

.detail::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #02cfe4;
}
.detail::-webkit-scrollbar-track {
  border-radius: 10px !important;
  background: rgba(24, 41, 72, 0.4);
}
::v-deep .el-loading-mask {
  background-color: transparent !important;
  opacity: 0.5 !important;
}
</style>
